import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const SeoTags = () => {
  const location = useLocation();
  const { language } = useLanguage();

  // Определяем текущую страницу и генерируем соответствующие мета-теги
  const getCurrentPageData = () => {
    const path = location.pathname;

    // Русские мета-теги
    const ruMeta = {
      '/': {
        title: 'StormHack Reloaded - Аудит безопасности серверов Minecraft',
        description: 'Профессиональный набор инструментов для анализа безопасности и стресс-тестирования серверов Minecraft. Обнаруживайте уязвимости вовремя.',
        keywords: 'Minecraft, RCON, DDoS, тестирование, безопасность, аудит, серверы, боты, аккаунты, защита'
      },
      '/rcon-audit': {
        title: 'RCON Audit - StormHack Reloaded',
        description: 'Анализ открытых портов RCON и тестирование устойчивости паролей. Обеспечьте безопасность вашего Minecraft сервера.',
        keywords: 'RCON, аудит, Minecraft, порты, пароли, безопасность, сканирование'
      },
      '/account-checker': {
        title: 'Проверка Аккаунтов - StormHack Reloaded',
        description: 'Поиск соответствующих учетных данных в нашей комплексной базе данных скомпрометированных аккаунтов Minecraft.',
        keywords: 'аккаунты, проверка, Minecraft, учетные данные, база данных, утечки'
      },
      '/ddos': {
        title: 'DDoS Тестирование - StormHack Reloaded',
        description: 'Анализ устойчивости сервера к распространенным векторам DDoS-атак. Проверьте защиту вашего сервера.',
        keywords: 'DDoS, тестирование, атака, сервер, защита, устойчивость'
      },
      '/servers': {
        title: 'Сервера - StormHack Reloaded',
        description: 'Просматривайте нашу базу данных доступных серверов для тестирования с мгновенным подключением.',
        keywords: 'сервера, база данных, Minecraft, тестирование, подключение'
      },
      '/server-data-extraction': {
        title: 'Извлечение Данных - StormHack Reloaded',
        description: 'Получите доступные данные сервера, такие как MOTD, списки игроков, плагины и многое другое.',
        keywords: 'данные, извлечение, сервер, MOTD, игроки, плагины'
      },
      '/bots': {
        title: 'Боты - StormHack Reloaded',
        description: 'Подготовьтесь к развертыванию бота для тестирования безопасности сервера Minecraft.',
        keywords: 'боты, развертывание, Minecraft, безопасность, тестирование'
      },
      '/secret': {
        title: 'Zero-day метод - StormHack Reloaded',
        description: 'Наш передовой проприетарный метод анализа использует уникальные алгоритмы для поиска критических уязвимостей.',
        keywords: 'zero-day, метод, анализ, безопасность, тестирование'
      },
      '/monitoring-parser': {
        title: 'Парсер Серверов - StormHack Reloaded',
        description: 'Анализируйте популярные сайты мониторинга серверов для поиска уязвимых серверов.',
        keywords: 'парсер, серверы, мониторинг, уязвимости, анализ'
      },
      '/account': {
        title: 'Аккаунт - StormHack Reloaded',
        description: 'Управление вашей подпиской и настройками аккаунта в StormHack.',
        keywords: 'аккаунт, подписка, настройки, профиль'
      },
      '/terms': {
        title: 'Условия использования - StormHack Reloaded',
        description: 'Условия использования сервиса StormHack Reloaded.',
        keywords: 'условия, использование, политика, сервис'
      }
    };

    // Английские мета-теги
    const enMeta = {
      '/': {
        title: 'StormHack Reloaded - Minecraft Server Security Audit Suite',
        description: 'Professional Minecraft server security auditing and stress testing suite. Discover and fix vulnerabilities.',
        keywords: 'Minecraft, RCON, DDoS, testing, security, audit, servers, bots, accounts, protection'
      },
      '/rcon-audit': {
        title: 'RCON Audit - StormHack Reloaded',
        description: 'Perform security audits on RCON ports and test password strength with advanced tools.',
        keywords: 'RCON, audit, Minecraft, ports, passwords, security, scanning'
      },
      '/account-checker': {
        title: 'Account Checker - StormHack Reloaded',
        description: 'Search for matching credentials in our comprehensive database of leaked Minecraft accounts.',
        keywords: 'accounts, checker, Minecraft, credentials, database, leaks'
      },
      '/ddos': {
        title: 'DDoS Testing - StormHack Reloaded',
        description: 'Analyze server resilience against common DDoS attack vectors. Test your server\'s protection.',
        keywords: 'DDoS, testing, attack, server, protection, resilience'
      },
      '/servers': {
        title: 'Servers - StormHack Reloaded',
        description: 'Browse our database of available servers to test with instant connection.',
        keywords: 'servers, database, Minecraft, testing, connection'
      },
      '/server-data-extraction': {
        title: 'Data Extraction - StormHack Reloaded',
        description: 'Retrieve available server data like MOTD, player lists, plugins and more.',
        keywords: 'data, extraction, server, MOTD, players, plugins'
      },
      '/bots': {
        title: 'Bots - StormHack Reloaded',
        description: 'Prepare for bot deployment to test Minecraft server security.',
        keywords: 'bots, deployment, Minecraft, security, testing'
      },
      '/secret': {
        title: 'Zero-day Method - StormHack Reloaded',
        description: 'Advanced proprietary security assessment technique using cutting-edge analysis algorithms.',
        keywords: 'zero-day, method, assessment, security, testing'
      },
      '/monitoring-parser': {
        title: 'Servers Parser - StormHack Reloaded',
        description: 'Analyze popular server monitoring sites to find vulnerable servers.',
        keywords: 'parser, servers, monitoring, vulnerabilities, analysis'
      },
      '/account': {
        title: 'Account - StormHack Reloaded',
        description: 'Manage your subscription and account settings in StormHack.',
        keywords: 'account, subscription, settings, profile'
      },
      '/terms': {
        title: 'Terms of Service - StormHack Reloaded',
        description: 'Terms of service for StormHack Reloaded platform.',
        keywords: 'terms, service, policy, platform'
      }
    };

    // Возвращаем мета-теги для текущего языка
    const currentMeta = language === 'ru' ? ruMeta[path] : enMeta[path];

    // Если для текущего пути нет специфических мета-тегов, используем общие
    if (!currentMeta) {
      return {
        title: language === 'ru' ? 'StormHack Reloaded' : 'StormHack Reloaded',
        description: language === 'ru'
          ? 'Продвинутый набор для тестирования безопасности серверов Minecraft'
          : 'Advanced Minecraft server security testing suite',
        keywords: language === 'ru'
          ? 'Minecraft, RCON, DDoS, тестирование, безопасность, аудит'
          : 'Minecraft, RCON, DDoS, testing, security, audit'
      };
    }

    return currentMeta;
  };

  const pageData = getCurrentPageData();

  // Генерируем hreflang ссылки
  const generateHreflangLinks = () => {
    const path = location.pathname;
    const baseUrl = 'https://stormblack.net';

    // Для главной страницы
    if (path === '/') {
      return (
        <>
          <link rel="alternate" hrefLang="ru" href={`${baseUrl}/`} />
          <link rel="alternate" hrefLang="en" href={`${baseUrl}/en/`} />
          <link rel="alternate" hrefLang="x-default" href={`${baseUrl}/`} />
        </>
      );
    }

    // Для остальных страниц
    return (
      <>
        <link rel="alternate" hrefLang="ru" href={`${baseUrl}${path}`} />
        <link rel="alternate" hrefLang="en" href={`${baseUrl}/en${path}`} />
        <link rel="alternate" hrefLang="x-default" href={`${baseUrl}${path}`} />
      </>
    );
  };

  return (
    <>
      <title>{pageData.title}</title>
      <meta name="description" content={pageData.description} />
      <meta name="keywords" content={pageData.keywords} />

      {/* Hreflang мета-теги */}
      {generateHreflangLinks()}

      {/* Язык страницы */}
      <meta property="og:locale" content={language === 'ru' ? 'ru_RU' : 'en_US'} />

      {/* Open Graph теги */}
      <meta property="og:title" content={pageData.title} />
      <meta property="og:description" content={pageData.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://stormblack.net${location.pathname}`} />

      {/* Twitter теги */}
      <meta name="twitter:title" content={pageData.title} />
      <meta name="twitter:description" content={pageData.description} />
      <meta name="twitter:card" content="summary" />
    </>
  );
};

export default SeoTags;
